var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2133_1721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 132
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.92 131.873C102.327 131.873 131.84 102.36 131.84 65.9532C131.84 29.5466 102.327 0.0332031 65.92 0.0332031C29.5134 0.0332031 0 29.5466 0 65.9532C0 102.36 29.5134 131.873 65.92 131.873Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2133_1721)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9191 131.871C102.326 131.871 131.839 102.358 131.839 65.9513C131.839 29.5447 102.326 0.03125 65.9191 0.03125C29.5124 0.03125 -0.000976562 29.5447 -0.000976562 65.9513C-0.000976562 102.358 29.5124 131.871 65.9191 131.871Z",
    fill: "url(#paint0_linear_2133_1721)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M103.687 117.392C131.649 96.6861 142.154 63.476 127.15 43.215C112.147 22.9541 77.3169 23.3147 49.3551 44.0205C21.3932 64.7263 10.8881 97.9365 25.8914 118.197C40.8947 138.458 75.7248 138.098 103.687 117.392Z",
    fill: "url(#paint1_radial_2133_1721)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.6396,
    y: -20.5078,
    width: 106.281,
    height: 108.873,
    fill: "url(#pattern0_2133_1721)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.02637,
    y: 81.4531,
    width: 99.3682,
    height: 76.0383,
    fill: "url(#pattern1_2133_1721)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22.2168,
    y: -12.7305,
    width: 85.5431,
    height: 93.3197,
    fill: "url(#pattern2_2133_1721)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M18.7837 25.7128C18.3085 29.627 27.7787 28.4173 39.9276 23.0082C52.0764 17.5992 62.3243 10.0472 62.7995 6.13293C63.2748 2.21868 53.7959 3.42838 41.6471 8.83747C29.4982 14.2466 19.2503 21.7985 18.7837 25.7128Z",
    fill: "url(#paint2_radial_2133_1721)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M61.6582 18.4802C56.638 19.3443 53.1126 23.5869 53.7779 27.985C54.4432 32.3831 59.0401 35.2346 64.0604 34.3791C69.0806 33.5237 72.5974 29.2725 71.932 24.8743C71.2667 20.4762 66.6699 17.6334 61.6582 18.4802Z",
    fill: "url(#paint3_radial_2133_1721)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2133_1721",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2133_1721",
    transform: "scale(0.00813008 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2133_1721",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2133_1721",
    transform: "scale(0.00869565 0.0113636)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_2133_1721",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2133_1721",
    transform: "scale(0.010101 0.00925926)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2133_1721",
    x1: 19.3024,
    y1: 19.3433,
    x2: 112.527,
    y2: 112.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2133_1721",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.7945 77.0245) rotate(53.48) scale(45.3596 62.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5A300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8B400",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2133_1721",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2037 11.0834) rotate(156.067) scale(24.0293 6.07813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2133_1721",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0648 21.7563) rotate(-98.4711) scale(8.04352 9.20956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2133_1721",
    width: 123,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2133_1721",
    width: 115,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAABYCAYAAADGKMgTAAAACXBIWXMAAAsSAAALEgHS3X78AAAD/UlEQVR4Xu2ca29UVRSGn1M6FC3R2qJFBY3cQkPgC/wD/7tfTPxgohIvGKHUlmIpt5QyhfHDe3Zm9zDY0g7OmpX3SSY70zOdnJznrMtep2kzGAwwOZg56ANmerDMRFhmIiwzEZaZCMtMhGUmwjITYZmJsMxEWGYiLDMRlpkIy0yEZSbCMhNhmYmwzERYZiIsMxGWmQjLTIRlJsIyE2GZibDMRFhmIiwzEZaZCMtMhGUmwjITMXvQBwLSdNbDMuis6ZgGmbW8BugBJ9v1sEIHQB942a610DSSI8tsUBmYBeaQvB7wMfAZ8FF77CChA2APeAI8aNd+dawreWrlRpRZJPaAeWAROIskzgPLwMV2nXvLd3TZBTaAP9p1lzclP0ZC++3xPeA1UyQ1msxa4hngK+AycBXJm2d/ZPZGf80b9NkfmXtIUlfycyR1Hdhq39cRG1psE+i/jTSoFi4hgSvAdeAKcB5JLKl2XDWzlvwYydsAbgO/AfeAbeBF++qjaA1JJJknkLDrwLfALZROl1BEFnnj7Ga7kvtI6j0k8zawimTfBzaBHYKm3yhptkHnsoQi8iZwA9XLkyj9vqu8Lm+7CWZQ7S1pdAGl+K+Ba0jgX8APwI/A38BTAkZpFJmgC3oW1ccLSOQpji/xILqSS90+jWrzDkr7y+hm+wm4g6K1RGkIoshsUJr9AEXGhxxu2/E+KOdSN2On29cyutG+A74H1lCKDpFyo8gcAK9QA/IQeAR8gi7oif/4vfdJqc8z6Ob6EnXQi+3xf1DztI3OfeJEkQnaJqyh2rSEauV5dCEnPUOeQeez0L5fQc3RXeAZQRqiKDJLV7mJZM4yFHiOodBJpN1CSb/zwBfAN+imW0epduJEkQm6u3fQVqCpfrYHfI5qVr09maTYkESSCao9O2ifV4/bVtA0aAF1uGVW+3+Krev6GvAnqpshohLiyYSh0FV0ocpE5ipKuWdQVzlKLCPW41CP8fqoPt4FfkFDhS2Go8GJE2kC1KXe7y2iVPspqleXUXdZxJY5bcPRxn2jKAJ30ShvG4n8maBbk8gyYbg1mEVReApF5DJDsZcYPkHpIbHvOogfRZnbbqDt0irKEL8SdGgQXWahro09JK6IrcXNcbRHZKMoT1R+RxG4iUZ5WyjdhhvnTYvMmq7YOqV2I/OoU6S6+XrA/icnYZ9zTqPMmlFNz7hrZvevEMJesGmXOYpxd7P1GpqIW5PjMlUCxsmkZ55mjFhmIiwzEZaZCMtMhGUmwjITYZmJsMxEWGYiLDMRlpkIy0yEZSbCMhNhmYmwzERYZiIsMxGWmQjLTIRlJsIyE2GZibDMRFhmIiwzEZaZCMtMhGUmwjITYZmJ+BeruP774/yeGgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2133_1721",
    width: 99,
    height: 108,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABsCAYAAAB+bQxAAAAACXBIWXMAAAsSAAALEgHS3X78AAAEiUlEQVR4Xu2d3W9URRyGn11LLZav2LCmWiSAIaKRCwl4Tfy7jdd+UC9MlBgCEcpXTflGSpU9XPxmsqeHbrtTSvc9h/dJNtNsTpMz58k7v5k507RXVRVGg/5OF5j9wzKEsAwhLEMIyxDCMoSwDCEsQwjLEMIyhLAMISxDCMsQwjKEsAwhLEMIyxDCMoSwDCEsQwjLEMIyhLAMISxDCMsQwjKEsAwhLEMIyxDCMoSwDCEsQ4iZnS5oOb1Gm6karQRdltEHDgAfpjYLqYD/gJepHW7521OgizJ6hIiDwHHgM+Aoo77+DzwCbgP/AC8QEdI1GTkNh4FF4DzwLfApMJeuWQdWgJ+BX4E7wAYCQ1aXZHxApGEAnAK+Bi4B3xAJOZCu2yAEANwF1tJ3U6crMrKIJSIJ3xEyThFy5hjNHF+ldokYvnI9cTL2gCziBHARuAxcIIapw8TDbk7hZ3mzsE+dtstoivg+tUvAR4SEcQ9bRkKmzTLGiTjBSESraN0NJzonAtp503slYuoFu8mkN65CXswtsXsReQW+kVoZKZPcvAo9YvYzIKavl9m9iCfA/dTKCJmkAyr0ianqaWIdcYHNs6ZJqIg9qfvANWAVkQUfTN6JaZOHp0Xgq/RZpEwEhIx1Yk/qDrFH5WQUUB+ezhNbHKeJlJTcfx6i6puE64iIgLLOTIv68HSJEDKgfPU8BJ4DN4GrxL6UZRQwbng6SNm951SsEbXiGvCA2E63jAnYq+EJRqn4G/g9tc8ReY+RKe3UftIHDhE7r28zPG2VijWECndGVUZOxQJwFjjH7oYnaEkqoLxj+0UfmAdOEi+HThIpKb3f1qQCyju3H9RT8UX6LFA+PEGLUgGaMrZKxTzl99qqVEB5B981PeIdy8fsTSqe0ZJUgKaMOaJYfwl8zu5SMQT+JRZ2fwJ/IZ4KKO/kuybLyOedjlGeiixiBVgGfgJuECmRTQVoyciF+xhxzuk4IaZERK4Tq8BvwI+pXUU8FaAlA+LUxoCoFZ8QJzhKZAyBp8B1IhHLREJkTg1uh5KMnIyjhIgjlA1R9TrxR/rcTd/ls1LSqMmYJQr2fPq5VMQKcIVIxXUiJfKJyKjIyKk4QqSiftJvJ7KIW8AvRJ1YpiV1oo6KDBjVizOpnd3+cuBNET+ktjV1oo6KjGYyJqkX40TcIkS0ok7UUZEBo9X3bGrfKxGgdbyzIt68bTD+DVzF5mLdGRGgI6N5nukxsfirz6jyNc+IKesVolh3QgToyIA4z3SPWB+cIRZ8hxjJyLJuEvtNzUVdq0WAjow8RK0RD3oAPCTWG1lGPnx2ldj4u0FMXzshAqAn9H/68qJvgTiyWd86z7KeEOl5QAxXUn+t+rYoyYCY3c0QG4QzbJ7t5ZrxkhAzpEULuklQkwGjYWmrqW3VaDuFSs2o0+kHvh1Ki773HssQwjKEsAwhLEMIyxDCMoSwDCEsQwjLEMIyhLAMISxDCMsQwjKEsAwhLEMIyxDCMoSwDCEsQwjLEMIyhLAMISxDCMsQwjKEsAwhLEMIyxDCMoSwDCFeAyRlKrh6uXpAAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowball);
export default __webpack_public_path__ + "static/media/yellowball.fb6c276b7e861f249878e92af8c0f0be.svg";
export { ForwardRef as ReactComponent };